import { render, staticRenderFns } from "./goDialogSurveyChains.vue?vue&type=template&id=2c52873c"
import script from "./goDialogSurveyChains.vue?vue&type=script&lang=js"
export * from "./goDialogSurveyChains.vue?vue&type=script&lang=js"
import style0 from "./goDialogSurveyChains.vue?vue&type=style&index=0&id=2c52873c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports